import { createFileRoute, redirect } from '@tanstack/react-router';
import { ORDER_BASE_PATH } from '../../../../features/order/order-routing';

export const Route = createFileRoute('/_app/_clearing-core/order/')({
  beforeLoad: () => {
    throw redirect({ to: ORDER_BASE_PATH });
  },
  preload: false,
});
